import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    text: "Prima passavamo mezz'ora al giorno a cercare frese e portautensili. Adesso l'operatore apre la scheda, vede magazzino e posizione e va a prenderlo. In due mesi abbiamo smesso di riordinare doppio.",
    who: "Andrea Bortolin",
    role: "Titolare",
    company: "Officina Meccanica Bortolin, Bassano del Grappa (VI)",
  },
  {
    text: "Il planner ci ha fatto vedere che il collo di bottiglia non era il centro a 5 assi ma la rettifica. Abbiamo spostato due fasi e recuperato quattro giorni sulla consegna.",
    who: "Fabio Lorenzi",
    role: "Responsabile di produzione",
    company: "Tecnomecc Srl, Reggio Emilia",
  },
  {
    text: "All'ultimo audit abbiamo aperto il piano di controllo del componente e mostrato quote, strumento usato e data di taratura. Mezza giornata invece di tre giorni di preparazione.",
    who: "Chiara Fenaroli",
    role: "Responsabile qualità",
    company: "Precision Parts SpA, Brescia",
  },
];

const CASE_ROWS = [
  { label: "Tempo per trovare un utensile in attrezzeria", before: "15-30 minuti", after: "meno di 1 minuto" },
  { label: "Fermi macchina per utensile mancante", before: "3 a settimana", after: "1 al mese" },
  { label: "Ore per preparare la documentazione di un audit", before: "24 ore", after: "4 ore" },
  { label: "Scostamento fra preventivo e consuntivo", before: "± 22 %", after: "± 6 %" },
  { label: "Referenze sotto scorta scoperte in ritardo", before: "9 su 10", after: "0" },
];

export function SocialProofSection() {
  return (
    <section className="landing-proof" id="testimonianze" data-testid="landing-proof">
      <div className="landing-section-head landing-reveal">
        <p className="landing-module-num">PROVA SOCIALE <i /> DALLE OFFICINE</p>
        <h2>Chi lo usa parla di minuti e di euro</h2>
        <p className="landing-desc">
          Non di «trasformazione digitale»: di utensili trovati, fermi macchina evitati e audit chiusi in
          mezza giornata.
        </p>
      </div>

      <div className="landing-proof-grid">
        {TESTIMONIALS.map((entry, index) => (
          <article
            className="landing-testimonial landing-reveal"
            style={{ transitionDelay: `${index * 80}ms` }}
            key={entry.who}
            data-testid={`landing-testimonial-${index + 1}`}
          >
            <Quote size={22} />
            <p className="landing-testimonial-text">«{entry.text}»</p>
            <p className="landing-testimonial-who">
              {entry.who} · {entry.role}<br />{entry.company}
            </p>
          </article>
        ))}
      </div>

      <div className="landing-case landing-reveal" data-testid="landing-case-study">
        <div className="landing-case-head">
          <p className="landing-module-num">CASO STUDIO <i /> PRIMA E DOPO</p>
          <h3>Officina Meccanica Bortolin · 18 addetti · 9 CNC</h3>
          <p className="landing-desc">
            Conto terzi per oleodinamica e packaging: 2.400 referenze fra utensili e attacchi base, tre
            magazzini e un solo attrezzista che sapeva dov'era ogni cosa. Catalogo importato da Excel in una
            giornata, scorte minime attivate in due settimane, planner in uso dal secondo mese.
          </p>
        </div>
        <table className="landing-case-table">
          <thead>
            <tr><th>Indicatore</th><th>Prima</th><th>Dopo sei mesi</th></tr>
          </thead>
          <tbody>
            {CASE_ROWS.map((row) => (
              <tr key={row.label}>
                <td>{row.label}</td>
                <td>{row.before}</td>
                <td className="is-after">{row.after}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
